import React, { useRef, useMemo, useEffect, useState } from 'react';
import axios from "axios";
import { Table, Row, Col } from 'react-bootstrap';
import { Link } from "react-router-dom";

const CompanyExpenses = () => {
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');

  const arabicMonthNames = [
    "يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
    "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
  ];

  // تحميل البيانات من API
  useEffect(() => {
    const getExpenses = async () => {
      try {
        const { data: apiData } = await axios.get('https://suhba.education.com.ly/back/api/getMonthlyExpenses');
        const sorted = apiData.sort((a, b) => a.date.localeCompare(b.date));
        const formatted = sorted.map(item => ({
          date: item.date,
            income: Number(item.income) || 0,
          employee_expenses: Number(item.employee_expenses) || 0,
          purchases: Number(item.purchases) || 0,
          rent: Number(item.rent) || 0,
          consumption_expenses: Number(item.consumption_expenses) || 0
        }));
        setAllData(formatted);
        setData(formatted); // عرض الكل عند التحميل
      } catch (err) {
        console.error("فشل في تحميل البيانات:", err);
      }
    };

    getExpenses();
  }, []);

  // فلترة البيانات
  const handleSearch = () => {
    const filtered = allData.filter(item => {
      const [itemYear, itemMonth] = item.date.split('-');
      const yearMatch = year ? itemYear === year : true;
      const monthMatch = month ? itemMonth === month.padStart(2, '0') : true;
      return yearMatch && monthMatch;
    });
    setData(filtered);
  };

  const handleClearSearch = () => {
    setMonth('');
    setYear('');
    setData(allData);
  };

  // الطباعة
  const printInvoice = () => {
    const printContents = document.getElementById('invoiceDiv').innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };

  return (
    <div className='container-fluid'>
      <Row>
        <Col lg="12">
          <div className="card">
            <div className="card-body p-0">
              <div className="tbl-caption d-flex justify-content-between align-items-center p-3">
                <h4 className="heading mb-0">مصروفات الشركة</h4>
                <Link to={"#"} className="btn btn-secondary btn-sm" onClick={printInvoice}>
                  <i className="fa-solid fa-print ms-1"></i> طباعه
                </Link>
              </div>

              {/* الفلترة */}
              <div className="row px-3 py-2">
                <div className="col-md-3">
                  <label className="form-label">الشهر</label>
                  <select className="form-control" value={month} onChange={e => setMonth(e.target.value)}>
                    <option value="">اختر الشهر</option>
                    {arabicMonthNames.map((name, index) => (
                      <option key={index + 1} value={(index + 1).toString()}>
                        {name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-3">
                  <label className="form-label">السنة</label>
                  <input className="form-control" type="text" placeholder="مثال: 2024" value={year} onChange={e => setYear(e.target.value)} />
                </div>

                <div className="col-md-4 d-flex align-items-end">
                  <button className="btn btn-primary btn-sm me-2" onClick={handleSearch}>ابحث</button>
                  <button className="btn btn-secondary btn-sm" onClick={handleClearSearch}>إلغاء</button>
                </div>
              </div>

              {/* جدول المصروفات */}
              <div className="table-responsive p-3" id="invoiceDiv">
                   <table className="table table-bordered text-center" dir="rtl" style={{ width: '100%', borderCollapse: 'collapse' }}>
  <thead style={{ position: 'sticky', top: 0, backgroundColor: 'rgba(189, 173, 235, 1)', zIndex: 2 ,color: 'black'}}>        

     <tr>
      <th>الشهر</th>
      <th>الدخل</th>
      <th>مصاريف الموظف</th>
      <th>المشتريات</th>
      <th>الإيجار</th>
      <th>مصاريف استهلاكية</th>
      <th>إجمالي المصروفات</th>
      <th>الصافي</th>
    </tr>
  </thead>
  <tbody>
    {data.map((item, index) => {
      const income = Number(item.income) || 0;
      const totalExpenses =
        item.employee_expenses +
        item.purchases +
        item.rent +
        item.consumption_expenses;
      const net = income - totalExpenses;

      return (
        <tr key={index}>
          <td>{item.date}</td>
          <td>{income}</td>
          <td>{item.employee_expenses}</td>
          <td>{item.purchases}</td>
          <td>{item.rent}</td>
          <td>{item.consumption_expenses}</td>
          <td><strong>{totalExpenses}</strong></td>
          <td><strong style={{ color: net < 0 ? 'red' : 'green' }}>{net}</strong></td>
        </tr>
      );
    })}
  </tbody>
</table>              </div>

              </div>
            </div>
         </Col>
      </Row>
    </div>
  );
};

export default CompanyExpenses;
